module.exports = __webpack_public_path__ + "img/盘古大模型开发ai优势bj.f8e79578.png";